import { render, staticRenderFns } from "./XbrlAnalysis.vue?vue&type=template&id=6931c7b6&"
import script from "./XbrlAnalysis.vue?vue&type=script&lang=js&"
export * from "./XbrlAnalysis.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports